export default __webpack_public_path__ + "static/media/img-onboarding.50999d02.png";